(function () {
    'use strict';

    //todo bei der patienten-suche die Images NICHT laden -> nicht notwendig. ansonsten zu viele img-requests
    //todo auch überlegen, die quicksearch sql funktion zu ändern: die contactinfos in einer funktion laden (xmlpath), damit immer nur ein user retouniert wird. 
    //todo in weiterer folge dann, wenn der patient ausgewählt wird (aus der such-liste) die contactinfos des users laden

    var module = angular.module('uwAgenda.global');
    module.directive('rfGlobalUserSearch', [
            '$compile', 
            'UserSearchService', 
            'SharedAgendaService', 
            'RoleType', 
            'ContactInfo', 
            'HelperService', 
            'UserService', 
            '$timeout', RfGlobalUserSearchDirectiveFn]);

    // // trigger on start the search if value exists and call is in progress
    // module.directive('triggerOnStart', ['$timeout', 'CallsService', 'CallPhoneStatus', '$state', function ($timeout, CallsService, CallPhoneStatus, $state) {
    //     return {
    //         link: function (scope, element) {
    //             var timer = null;


    //             // if CONNECTED-Call and no patient pre-selected -> set PHONE-Number And Search for it
    //             // if (CallsService.call.phoneStatus === CallPhoneStatus.CONNECTED && 
    //             //     CallsService.call.caller === null) {

    //             if (CallsService.call.talkingTo) {

    //                 timer = $timeout(function () {
    //                     element.val(CallsService.call.talkingTo);
    //                     element.trigger("change");

    //                     // Clear the phonenumber in the CallService after one use
    //                     CallsService.call.talkingTo = '';
    //                 }, 0);
    //             } // if

    //             // destroy
    //             scope.$on("$destroy", function () {
    //                 if (timer !== null) { $timeout.cancel(timer) };
    //                 timer = null;
    //             });

    //         }
    //     };
    // }]);

    /* directive for searching user */
    function RfGlobalUserSearchDirectiveFn($compile, UserSearchService, SharedAgendaService, RoleType, ContactInfo, HelperService, UserService, $timeout) {
        var directive = {
            link: link,
            restrict: 'E',
            replace: true,
            templateUrl: '/app/global/templates/rf-global-user-search.template.html',
            scope: {                
                user: '=',
                showImage: '@?', // default true //todo-alex wird das überhaupt irgendwo gesetzt
                appendToBody: '@?',
                search: '&?', // optional parameter
                showContactInfos: '@?', // should contact-infos be shown in list
                required: '@?', // optional parameter (default false)
                includeCurrentUser: '@?', //optional parameter
                restrictedRoles: '@?', // restricted roles for searching
                isPatientSearch: '@?',
                focus: '@?'
            }
        };
        return directive;


        function link(scope, element) {
            if (!scope.user) {
                scope.user = {};
            }

            // search caption set
            if (!scope.user.firstName) {
                scope.user.firstName = '';
            }

            if (!scope.user.lastName) {
                scope.user.lastName = '';
            }

            if (scope.user) {                
                scope.firstNameUser = scope.user;
                scope.lastNameUser = scope.user;                
            } // if

            // default values 
            if (typeof scope.required === 'undefined') { scope.required = false; }
            if (typeof scope.showImage === 'undefined') { scope.showImage = true; }
            
            scope.append = scope.appendToBody === 'true' ? true : null;

            setTimeout(function() {
                if (scope.focus === 'true') {
                    element.find('input')[0].focus();
                }
            }, 0);

            // restricted roles types
            var restrictedRoles = [];
            // restrict user-role-search by current-id ?
            var restrict = true; // default

            // watchers
            var watchOutside = null;
            var firstNameWatcher = null;
            var lastNameWatcher = null;

            activate();

            // activation work
            function activate() {

                // model to interact with
                scope.selected = {
                    user: scope.user ? scope.user : null
                };

                // show contact infos ?
                if (typeof scope.showContactInfos === 'undefined') { scope.showContactInfos = false; } // default NO

                firstNameWatcher = scope.$watch(function () { return scope.firstNameUser; }, function (newVal) {
                    if (typeof scope.firstNameUser === 'string') {
                        scope.user.firstName = scope.firstNameUser;
                    }
                    
                });
                lastNameWatcher = scope.$watch(function () { return scope.lastNameUser; }, function (newVal) {
                    if (typeof scope.lastNameUser === 'string') {
                        scope.user.lastName = scope.lastNameUser;
                    }
                });

                    // if user object is set from outside of the directive
                watchOutside = scope.$watch(function () { return scope.user; }, function (newUser) {                    

                    scope.selected.user = newUser;       
                    if (newUser) {                
                        scope.firstNameUser = newUser;
                        scope.lastNameUser = newUser;                
                    }
                    
                    // replace img
                    element.find('img').remove();

                    // // add img directive
                    // if (newUser && newUser.id && scope.showImage) {
                    //     // new element
                    //     var elImg = '<user-image user-id="' + newUser.id + '" class="flex-item img-circle" thumb-width="27" style="align-self:flex-start; flex-grow: 0; margin-right:5px;"></user-image>&nbsp;&nbsp;';
                    //     element.prepend($compile(elImg)(scope));
                    // } //if
                });

                /* restricted role type parameter defines which roles should be searched */
                if (typeof scope.restrictedRoles !== 'undefined' && scope.restrictedRoles !== null) {
                    switch (scope.restrictedRoles) {
                        case 'AgendaOwners': {
                            restrictedRoles = [RoleType.MainUser.value, RoleType.RingfoonAdmin.value];
                            restrict = false;
                            break;
                        }
                        case 'NoPatients': {
                            restrictedRoles = HelperService.noPatientRoles();
                            restrict = true;
                            break;
                        }
                        case 'Patients': {
                            restrictedRoles = [RoleType.Patient.value, RoleType.Representative.value];
                            restrict = true;
                            break;
                        }
                    }
                }

                scope.modelOptions = {
                    debounce: {
                        default: 250,
                        blur: 250
                    },
                    getterSetter: true
                };
                
            } //activate

            /* reset */
            scope.reset = function () {                
                scope.firstNameUser = null;
                scope.lastNameUser = null;
                
                var emptyUser = {
                    id: 0,
                    caption: '',                
                    firstName: '',
                    lastName: '',                    
                    birthday: null,
                    contactInfos: [],
                    protocols:  [],
                    detail: {
                        street: null,
                        streetNumber: null,
                        zipCode: null,
                        location: null,
                        fK_Country: null,
                        // view model
                        country: null
                    }
                };
                scope.user = emptyUser;

                element.find('#lastName').focus();
            };

            scope.selectInFirstNameField = function (item, model, label, event) { 
                scope.selected.user = scope.firstNameUser; 
                scope.lastNameUser = scope.selected.user;

                scope.doSelect(item, model, label, event);
            };

            scope.selectInLastNameField = function (item, model, label, event) { 
                scope.selected.user = scope.lastNameUser;
                scope.firstNameUser = scope.selected.user;

                scope.doSelect(item, model, label, event);
            };


            // select
            scope.doSelect = function (item, model, label, event) {
                if (event) {
                    event.preventDefault();
                    event.stopPropagation();
                }

                if (scope.isPatientSearch !== undefined) {
                    // contact-infos by selected user
                    UserService.contactInfosByUser(scope.selected.user.id).then(function (result) {
                        scope.user = scope.selected.user;
                        scope.user.contactInfos = result;
                    });
                }
                else {
                    scope.user = scope.selected.user;
                }
                if (scope.selected.user && scope.selected.user.detail) {
                    // show warnings of patients after it has been selected
                    UserService.showSpecificPatientWarning(scope.selected.user.caption, scope.selected.user.detail.warningInfo);
                }
            };

            scope.searchUserByFirstName = function(firstName)  {
                if (!scope.user) {
                    scope.user = {};
                }

                scope.user.firstName = firstName;
                
                return HelperService.enoughCharactersForFilterCheck(firstName) && searchUser(firstName);
            };
            
            scope.searchUserByLastName = function(lastName)  {
                if (!scope.user) {
                    scope.user = {};
                }

                scope.user.lastName = lastName;
                return HelperService.enoughCharactersForFilterCheck(lastName) && searchUser(lastName);
            };

            // search for user items
            function searchUser(searchValue) {

                // if function is available
                if (typeof scope.search !== 'undefined' && scope.search && angular.isFunction(scope.search)) {
                    // callback search function
                    return scope.search({ searchValue: searchValue });
                } // if

                // restrict to specific roles -> role-type-search
                if (typeof scope.restrictedRoles !== 'undefined') {
                    return UserSearchService.searchByRoleTypes(searchValue, restrictedRoles, restrict);
                } // if

                // do quick search
                return UserSearchService.quicksearch(searchValue, scope.showContactInfos).then(function (result) {

                    if (!scope.includeCurrentUser) {
                        // current user should not be selectable -> pin to self is not allowed

                        // $filter cant be used because of Not-Equal logic -> splice is faster
                        var currentId = SharedAgendaService.currentUser().id;
                        var len = result.length;
                        for (var i = len - 1; i >= 0; i--) {
                            // remove current user
                            if (result[i].id === currentId) {
                                result.splice(i, 1);
                            }
                        }
                    } //if                   

                    return HelperService.prepareUserSearchResult(result);
                });
            }


            // destroy
            scope.$on('$destroy', function () {
                if (watchOutside) {
                    watchOutside();
                    watchOutside = null;
                }
                if (lastNameWatcher) {
                    lastNameWatcher();
                    lastNameWatcher = null;
                }
                if (firstNameWatcher) {
                    firstNameWatcher();
                    firstNameWatcher = null;
                }
            });

        }
    }
})();